module.exports = __webpack_public_path__ + "img/dcu30-6.8f279219.png";